import React, { FC, ReactNode } from 'react'
import './ModalSubtitle.scss'

interface Props {
  children?: ReactNode
}

export const ModalSubtitle: FC<Props> = ({ children }) => <div className="modal-header-subtitle">{children}</div>
